import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Post Countries',
  basePath: '/post-countries',
  columns: [
    { key: 'region_name', label: 'Region', sortable: true },
    { key: 'country_name', label: 'Country', sortable: true },
  ],
  fields: [
    { key: 'region', label: 'Region', type: 'async-select',
      optionsUrl: '/post-regions/options', required: true },
    { key: 'expo_country', label: 'Country', type: 'async-select',
      optionsUrl: '/expo-countries/options', required: true },
  ],
  defaultSort: { field: 'region_name', dir: 'asc' },
});
